import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import Iframe from "react-iframe";
import { TUTORIAL_VIDEO_URL, ACCESS_FILES_API_KEY } from "Constants";
import LocaleStrings from "Languages";
import Loader from "Loader";
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class InfoTutorial extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      loading: true,
      desc: LocaleStrings.eventify_documentation,
    };
  }

  open() {
    this.setState({ showModal: true });
  }

  close() {
    this.setState({ showModal: false });
    this.setState({
      loading: true,
    });
  }

  hideSpinner = () => {
    this.setState({
      loading: false,
    });
  };

  render() {
    let videourl =
      TUTORIAL_VIDEO_URL + "about.mp4" + "?api_key=" + ACCESS_FILES_API_KEY;
    var docUrl = "https://hub.eventify.io/docs/";

    return (
      <div>
        <Button
          className="btn-custom-blue schedule-add-button"
          onClick={(e) => this.open(e)}
        >
          <i
            className="fa fa-info i-custom-normal i-custom-ms"
            aria-hidden="true"
          ></i>
          {LocaleStrings.help_docs}
        </Button>

        <Modal
          className="modal-container modal-info"
          show={this.state.showModal === true ? true : false}
          onHide={this.close}
          animation={true}
          keyboard={false}
          backdrop="static"
          style={{ marginTop: "40px" }}
          size="xl"
        >
          <Modal.Header>
            <div className="import-modal-title">
              {LocaleStrings.eventify_documentation}
            </div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={(e) => this.close()}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <Modal.Body>
            {/* New change added  as help doc instead of video tutorial*/}
            {this.state.loading ? (
              <div className="loader-container">
                <Loader />
                <div className="loader-info">{this.state.desc}</div>
              </div>
            ) : null}
            <div className={classNames(this.state.loading ? "hidden" : "")}>
              <Iframe
                url={docUrl}
                width="100%"
                height="400px"
                onLoad={this.hideSpinner}
                id="webbrowser"
                display="initial"
                position="relative"
                className="helpdoc-iframe"
              />
              <div className="d-flex">
                <p>{LocaleStrings.eventify_visit_doc_website}</p>
                <a href={docUrl} target="_blank">
                  <p>{docUrl} </p>
                </a>
              </div>
            </div>
            {/* Commneted reason: requirement is not embedded. */}
            <div>
              {/* <Iframe
                url="https://www.youtube.com/embed/MImdGD214JI"   //Note: for using youtube links in iframe, always put '/embed' after 'www.youtube.com' (as of September, 2020)
                width="538px"
                height="269px"
                id="webbrowser"
                display="initial"
                position="relative"
                style={{ borderStyle: 'none', borderWidth: 0 }}
              /> */}
            </div>

            {/* <div>
              <video
                className='reply_img-lg cp'
                disablePictureInPicture
                loop
                controls
                controlsList="nodownload"
                preload="metadata"
                onError={this.fallback}
                style={{width: 540}}
              > */}
            {/* <source src={imgUrl + '#t=0.1'} type="video/mp4" /> */}
            {/* <source src={`https://eventify.io/docs/videos/${this.props.video}` + '#t=0.1'} type="video/mp4" />
                  Sorry, your browser doesn't support embedded videos.
              </video>
            </div> */}

            {/* Commented reason: React video <Player/> not working, making UI issues. */}
            {/* <div className="row">
              <div className="col-md-12">
                <Player className="slide-media-display p-0">
                  <source src={`${videourl}#t=0.1`} />
                </Player>
              </div>
            </div> */}
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-custom-white"
              onClick={(e) => this.close()}
            >
              {LocaleStrings.button_close}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
  };
}

export default connect(mapStateToProps, {})(InfoTutorial);
